import { useForm } from "react-hook-form";
import { IStructureVacancyRequestDto } from "@src/entities/requestHH/api/interfaces/jobRequestDto";
import { VacancyDescriptionStep } from "../VacancyDescriptionStep/VacancyDescriptionStep";
import { yupResolver } from "@hookform/resolvers/yup";
import { vacancyDescriptionSchema } from "./constans";

interface Props {
  isLoading: boolean;
  onSubmit: (values: IStructureVacancyRequestDto) => void;
}

export const VacancyDescription = ({ isLoading, onSubmit }: Props) => {
  const vacancyForm = useForm<IStructureVacancyRequestDto>({
    defaultValues: {
      vacancy_name: "",
      vacancy_description: "",
      user_comments: "",
    },
    resolver: yupResolver(vacancyDescriptionSchema) as any,
    mode: "onChange",
  });

  return (
    <VacancyDescriptionStep
      form={vacancyForm}
      isLoading={isLoading}
      onSubmit={onSubmit}
    />
  );
};
